// Must stay in step with website/js/export-cart-pdf.js (legacy /share); tests/exportCartPdf.spec.ts checks parity.
import { decode } from 'html-entities';

import type { ExportableCart } from '../../types/cart';
import { exportedItemPrice, exportedItemTitle } from '../exportToExcel/exportedItemPrice';
import { formatPrice } from '../formatPrice';
import { itemOutboundHref } from '../withSource';

export type CartPdfRow = {
  title: string;
  link: string;
  id: string;
  sku: string;
  quantity: number;
  unit: string;
  total: string;
};

export type CartPdfTable = {
  rows: CartPdfRow[];
  totalQuantity: number;
  grandTotal: string;
};

// 'en-US', not 'us': Intl falls back to the browser locale for 'us', which varies per user.
const money = (amount: number, ccy: string, ccyS: string) =>
  formatPrice(amount, 'en-US', ccy, ccyS, false);

export const buildCartPdfRows = ({ ccy, ccyS, items }: ExportableCart): CartPdfTable => {
  let totalQuantity = 0;
  let grandTotal = 0;

  const rows = items.map((item) => {
    const quantity = Number(item.quantity) || 0;
    const unit = exportedItemPrice(item);
    totalQuantity += quantity;
    grandTotal += (unit ?? 0) * quantity;

    return {
      title: decode(exportedItemTitle(item)),
      link: itemOutboundHref(item.url),
      id: item.asin,
      sku: item.skuString || item.sku || '',
      quantity,
      unit: unit === null ? '' : money(unit, ccy, ccyS),
      total: unit === null ? '' : money(unit * quantity, ccy, ccyS),
    };
  });

  return { rows, totalQuantity, grandTotal: money(grandTotal, ccy, ccyS) };
};
